// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { categoryListStyles } from "@tps/Overrides/Widgets/Category/CategoryList";
import { xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

categoryListStyles.container = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        column-gap: 22px;
        row-gap: 32px;
        justify-content: center;
        ${xScreen("lte", "sm")} {
            column-gap: 20px;
        }
    `,
};

categoryListStyles.categoryItemStyles = {
    categoryItem: {
        css: css`
            ${xScreen("lte", "md")} {
                width: 228px;
            }
        `,
    },
    categoryTitle: {
        css: css`
            margin-top: 12px;
        `,
    },
    image: {
        css: css`
            width: 100%;
            height: 204px;
            ${xScreen("lte", "md")} {
                height: 228px;
            }
        `,
    },
};

categoryListStyles.subCategoryNameLinkItem = {
    css: css`
        text-align: center;
    `,
};
